module.exports = __webpack_public_path__ + "static/media/screen-primary-05.4278ab2a.jpg";